import { render, staticRenderFns } from "./SurveyBox.vue?vue&type=template&id=ee1aa80a&scoped=true&"
import script from "./SurveyBox.vue?vue&type=script&lang=js&"
export * from "./SurveyBox.vue?vue&type=script&lang=js&"
import style0 from "./SurveyBox.vue?vue&type=style&index=0&id=ee1aa80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1aa80a",
  null
  
)

/* custom blocks */
import block0 from "./SurveyBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee1aa80a')) {
      api.createRecord('ee1aa80a', component.options)
    } else {
      api.reload('ee1aa80a', component.options)
    }
    module.hot.accept("./SurveyBox.vue?vue&type=template&id=ee1aa80a&scoped=true&", function () {
      api.rerender('ee1aa80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/SurveyBox.vue"
export default component.exports